import { ScopeVersion } from '@app/core/model/scope-version'
import { ScopeChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/scope-with-changes.interface'

export function getScopeChanges(scope: ScopeVersion, previewScope: ScopeVersion): ScopeChanges {
  if (!previewScope) previewScope = scope

  return {
    scopeMarginPercentage: {
      old: +scope?.getMarginPercentage(),
      new: +previewScope?.getMarginPercentage(),
    },
    totalProfit: {
      old: scope?.getTotalProfit()?.amount,
      new: previewScope?.getTotalProfit()?.amount,
    },
    markup: {
      old: scope?.getMarkup(),
      new: previewScope?.getMarkup(),
    },
    totalRateCardHours: {
      old: scope?.getTotalRateCardHours(),
      new: previewScope?.getTotalRateCardHours(),
    },
    budgetBalance: {
      old: scope?.getBudgetBalance()?.amount,
      new: previewScope?.getBudgetBalance()?.amount,
    },
    deliverableBudgetTotal: {
      old: scope?.getTotalDeliverableBudget()?.amount,
      new: previewScope?.getTotalDeliverableBudget()?.amount,
    },
    totalSellingPrice: {
      old: scope?.getTotalSellingPrice()?.amount,
      new: previewScope?.getTotalSellingPrice()?.amount,
    },
    totalPercentageComplete: {
      old: scope?.totalPercentageComplete(),
      new: previewScope?.totalPercentageComplete(),
    },
    totalActualHours: {
      old: scope?.totalActualHours(),
      new: previewScope?.totalActualHours(),
    },
  }
}
